import React from "react";
import GoogleAd from "./GoogleAd";
import { useSideRailWidth } from "./GoogleAdSideRail";
import { isNativeBannerAvailable } from "../utils/nativeAds";

// Anuncio de AdSense dentro del contenido para cuando el lateral
// (GoogleAdSideRail) no entra: celulares y notebooks de 1280/1366 px. Se
// monta con las mismas condiciones que el lateral (solo con contenido en
// pantalla). En la app Android no va: ahí está el banner nativo de AdMob.
const GoogleAdInline = ({ sx }) => {
  const railWidth = useSideRailWidth();
  if (railWidth || isNativeBannerAvailable()) return null;
  return <GoogleAd sx={{ my: 3, ...sx }} />;
};

export default GoogleAdInline;
